import React from "react";
import DataDisplay from "../../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const DataPoints = () => {
  const dataPoints = useSelector((state) => state.pastDuesCollections.chartsData.dataPoints);
  const { qa, currencySymbol } = useSelector((state) => state.commonReducer.commonProps);

  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map(({ label, value, type, url }) => {
        return (
          <div key={label} className="data-point">
            <DataDisplay
              disableAnimation={qa}
              label={label}
              value={value}
              type={type}
              currency={currencySymbol}
              url={url}
            />
          </div>
        );
      })}
    </div>
  );
};
